import AddOrderCommentModal from './AddOrderCommentModal.js'
import AddressLabelModal from './AddressLabelModal.js'
import BatchModals from '../../BatchListPage/Modals/index.js'
import ConfirmLabelDeleteModal from './ConfirmLabelDeleteModal.js'
import ConfirmMarkAsShippedModal from './ConfirmMarkAsShippedModal.js'
import ConfirmOrderCancelModal from './ConfirmOrderCancelModal.js'
import ConfirmOrderLineDeleteModal from './ConfirmOrderLineDeleteModal.js'
import ConfirmOrderOnHoldModal from './ConfirmOrderOnHoldModal.js'
import ConfirmTrackingWritebackModal from './ConfirmTrackingWritebackModal.js'
import CreateReturnOrderModal from '../../ReturnOrderListPage/Modals/CreateReturnOrderModal/index.js'
import DeleteTrackingModal from './DeleteTrackingModal.js'
import EditOrderLineModal from './EditOrderLineModal.js'
import EditOrderWarehouseModal from './EditOrderWarehouseModal.js'
import EditTrackingNumberModal from './EditTrackingNumberModal.js'
import MarkAsAwaitingFulfillmentModal from './MarkAsAwaitingFulfillmentModal.js'
import MergeOrdersModal from './MergeOrdersModal.js'
import OrderRevisionModal from './OrderRevisionModal.js'
import OrderTextFieldModal from './OrderTextFieldModal.js'
import OrderTotalsModal from './OrderTotalsModal.js'
import PackingOrderModal from '../../PackShipPage/Modals/PackingOrderModal.js'
import ParentOrderModal from './ParentOrderModal.js'
import PickOrdersModal from '../../PackShipPage/Modals/PickOrdersModal.js'
import PickupModal from './PickupModal/index.js'
import ProcessDropshipModal from './ProcessDropshipModal.js'
import QuickShipModal from './QuickShipModal/index.js'
import RestoreOrderModal from './RestoreOrderModal.js'
import ScanFormModal from './ScanFormModal/index.js'
import SendInvoiceModal from './SendInvoiceModal.js'
import SplitOrderModal from './SplitOrderModal.js'

export default function Modals() {
  return (
    <>
      <AddOrderCommentModal />
      <AddressLabelModal />
      <BatchModals />
      <ConfirmLabelDeleteModal />
      <ConfirmMarkAsShippedModal />
      <ConfirmOrderCancelModal />
      <ConfirmOrderLineDeleteModal />
      <ConfirmOrderOnHoldModal />
      <ConfirmTrackingWritebackModal />
      <CreateReturnOrderModal />
      <DeleteTrackingModal />
      <EditOrderLineModal />
      <EditOrderWarehouseModal />
      <EditTrackingNumberModal />
      <MarkAsAwaitingFulfillmentModal />
      <MergeOrdersModal />
      <OrderRevisionModal />
      <OrderTextFieldModal />
      <OrderTotalsModal />
      <PackingOrderModal />
      <ParentOrderModal />
      <PickOrdersModal />
      <PickupModal />
      <ProcessDropshipModal />
      <QuickShipModal />
      <RestoreOrderModal />
      <ScanFormModal />
      <SendInvoiceModal />
      <SplitOrderModal />
    </>
  )
}
